import { MAX_STAGE, STAGES } from '@/constants/constants';
import { ItemMap, Stage } from '@/models/models';
import { solve } from 'yalps';

type VariableRow = { cost: number } & Record<string | number, number>;
type Variables = Record<number, VariableRow>;
type Constraints = Record<string, { min: number }>;

function constructVariables(itemsNeeded: ItemMap): Variables {
  const variables: Variables = {};
  console.debug(itemsNeeded);

  for (const cam of STAGES as Stage[]) {
    if (cam.Area > MAX_STAGE || cam.Difficulty === 1) continue;

    const rewards = (cam.ServerData?.Cn?.Rewards ?? []).filter(
      (r) => r.Type === 'Equipment' && r.RewardType !== 'FirstClear' && r.Chance !== undefined,
    );

    let hasNeeded = false;
    const itemDropTable: Record<number, number> = {};
    for (const r of rewards) {
      if (itemsNeeded[r.Id]) {
        hasNeeded = true;
        itemDropTable[r.Id] = r.Chance!;
      }
    }

    if (!hasNeeded) continue;

    const cost = cam.EntryCost[0]?.[1];
    if (typeof cost !== 'number') continue;

    variables[cam.Id] = { cost, ...itemDropTable } as VariableRow;
  }

  return variables;
}

function shouldUserFarm(itemsNeeded: ItemMap, itemsOwned: ItemMap): boolean {
  for (const id in itemsNeeded) {
    if (itemsNeeded[id] - (itemsOwned[id] ?? 0) > 0) return true;
  }
  return false;
}

export function calculateFarmingPlan(itemsNeeded: ItemMap, itemsOwned: ItemMap) {
  if (!shouldUserFarm(itemsNeeded, itemsOwned)) return;

  const constraints: Constraints = {};
  for (const id in itemsNeeded) {
    const gap = itemsNeeded[id] - (itemsOwned[id] ?? 0);
    if (gap > 0) constraints[id] = { min: gap };
  }

  const variables = constructVariables(itemsNeeded);

  const model = {
    direction: 'minimize' as const,
    objective: 'cost',
    constraints,
    variables,
  };

  console.debug('LP Model', model);
  const solution = solve(model);
  console.debug('Proposed Solution', solution);
  return solution;
}
